module.exports = __webpack_public_path__ + "static/media/photo46.2bbdc294.jpg";